import z from "zod";
import { projectsId, organizationsId } from "../../db_gen";

const avatarUploadSchema = z.object({
  filename: z.string().min(1),
  mimeType: z.string().regex(/^image\/(jpeg|jpg|png|webp|gif)$/),
});

const organizationLogoUploadSchema = z.object({
  organizationId: organizationsId,
  filename: z.string().min(1),
  mimeType: z.string().regex(/^image\/(jpeg|jpg|png|webp|gif)$/),
});

const projectImageUploadSchema = z.object({
  projectId: projectsId,
  filename: z.string().min(1),
  mimeType: z.string().regex(/^image\/(jpeg|jpg|png|webp|gif)$/),
});

const completeAvatarUploadSchema = z.object({
  uploadKey: z.string(),
});

const completeOrganizationLogoUploadSchema = z.object({
  organizationId: organizationsId,
  uploadKey: z.string(),
});

const completeProjectImageUploadSchema = z.object({
  projectId: projectsId,
  uploadKey: z.string(),
});

const deleteProjectImageSchema = z.object({
  projectId: projectsId,
});

export default {
  avatar: {
    getPresigned: avatarUploadSchema,
    complete: completeAvatarUploadSchema,
  },
  organizationLogo: {
    getPresigned: organizationLogoUploadSchema,
    complete: completeOrganizationLogoUploadSchema,
  },
  projectImage: {
    getPresigned: projectImageUploadSchema,
    complete: completeProjectImageUploadSchema,
    delete: deleteProjectImageSchema,
  },
};
